module.exports = __webpack_public_path__ + "static/media/carousel-prev.1ee9ef64.svg";